export enum PanelType {
    VIDEO = 'video',
    MAP = 'map',
    FRAME_PARENT = 'frame_parent',
    FRAME_HISTOGRAM = 'frame_histogram'
}
